var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShapeP = function SvgShapeP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 254 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 126.55c0 34.894 13.958 66.532 37.22 89.329 22.798 22.798 54.436 37.221 89.33 37.221h.93V126.55H0Z",
    fill: "#2E72DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M126.55 0C56.761 0 0 56.761 0 126.55h127.48V253.1c69.324-.466 125.62-56.762 125.62-126.55C252.634 56.761 196.338 0 126.55 0Z",
    fill: "#61D8F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 126.55V308h127.48V126.55H0Z",
    fill: "#2E72DF"
  })));
};
export default SvgShapeP;